import axios from 'axios';
import UserService from '../components/auth/UserService';
import settingsService from '../services/settingsService';

const httpClient = axios.create();

httpClient.interceptors.request.use(config => {
    return UserService.getAccessToken(settingsService.authConfig).then(access_token => {
        config.headers.Authorization = `Bearer ${access_token}`;
        return config;
    });
});

httpClient.interceptors.response.use(function (response) {
    return response.data;
});

export default httpClient;